export const GET_JOBS = 'GET_JOBS';
export const GET_CITIES = 'GET_CITIES';
export const GET_PROJECT = 'GET_PROJECT';
export const GET_COMPANY_INFO = 'GET_COMPANY_INFO';
export const GET_INSTAGRAM_POST = 'GET_INSTAGRAM_POST';

export default {
  [GET_JOBS]: state => state.jobs,
  [GET_CITIES]: state => state.cities,
  [GET_PROJECT]: state => state.project,
  [GET_COMPANY_INFO]: state => state.companyInfo,
  [GET_INSTAGRAM_POST]: state => state.instagram_post,
};



// WEBPACK FOOTER //
// ./src/store/getters.js